import Component from 'vue-class-component';
import PageBase from '@/pages/page-base';
import MapFeaturesService from '@/services/map-features.service';
import Feature from '@/interfaces/geo/feature.interface';
import MapObject from '@/interfaces/entities/map-object.interface';
import {Observable, of} from 'rxjs';
import {map} from 'rxjs/operators';
import ApiService from '@/services/api.service';
import Filters from '@/library/filter/filters';

@Component({})
export default class FavoritesApp extends PageBase {

    public mapObjects: MapObject[] = [];
    private mapFeaturesService = MapFeaturesService.getInstance();
    private apiService = ApiService.getInstance();
    private paramId = 'objekts';

    constructor(options: any) {
        super(options);
    }

    public run(): void {
        this.fetchAndRender().subscribe(() => {
            this.mapObjects = this.mapObjects.filter((object: MapObject) => {
                return object.myFavorite;
            })
        });
    }

    public openMapObject(mapObject: MapObject): void {
        const route = this.apiService.routes().map;
        window.location.href = `${route}?${this.paramId}=${encodeURIComponent(mapObject.id)}`;
    }

    private fetchAndRender(): Observable<void> {
        return this.mapFeaturesService.objectFeatures(new Filters()).pipe(
            map((features: Feature[]) => {
                this.mapObjects = features.map((feature: Feature): MapObject => {
                    return this.mapObjectFromFeature(feature);
                })
            })
        );
    }

    private mapObjectFromFeature(feature: Feature): MapObject {
        return this.mapFeaturesService.mapObjectFromObjectFeature(feature);
    }
}
